const DEFAULT_CONTEXT = {
  title: 'GitMe workspace',
  description: 'Ask about the metrics and next steps on this page.',
  starters: [
    'Explain the key metrics on this page.',
    'What should I review next?'
  ]
};

const CONTEXTS = {
  '/': {
    title: 'Executive Summary',
    description:
      'Understand the signals shaping your engineering organisation.',
    starters: [
      'What does REV mean in GitMe, and how should I interpret it?',
      'What is the most important engineering trend to review on this Executive Summary?'
    ]
  },
  '/dev-feed': {
    title: 'DevFeed',
    description: 'Explore the recent work and the signals behind it.',
    starters: [
      'What recent delivery activity needs my attention?',
      'Summarize the most meaningful changes in this DevFeed.'
    ]
  },
  '/company-insights': {
    title: 'Company Overview',
    description: 'Understand the organisation-wide productivity picture.',
    starters: [
      'What is the strongest company-level productivity signal here?',
      'Which area should leadership investigate next?'
    ]
  },
  '/developers-insights': {
    title: 'Developers Overview',
    description: 'Review individual delivery health and contribution patterns.',
    starters: [
      'Which developers show the strongest delivery momentum?',
      'Where should we investigate a change in developer health?'
    ]
  },
  '/certifications': {
    title: 'Certifications',
    description: 'Review verified engineering recognitions and eligibility.',
    starters: [
      'Which certification is closest to being earned?',
      'What evidence supports the current certification status?'
    ]
  },
  '/performance-overview': {
    title: 'Performance Overview',
    description: 'Compare engineering effort across time and ownership.',
    starters: [
      'What is the main performance trend in this period?',
      'Which contributor or area accounts for the biggest change?'
    ]
  },
  '/developers': {
    title: 'Developers',
    description: 'Explore effort distribution and developer trends.',
    starters: [
      'Which developers contributed the most engineering effort?',
      'How is effort distributed across the developer team?'
    ]
  },
  '/repos': {
    title: 'Repositories',
    description: 'Understand repository-level effort and delivery trends.',
    starters: [
      'Which repositories receive the most engineering investment?',
      'Where has repository activity changed most recently?'
    ]
  },
  '/categories': {
    title: 'Work Categories',
    description: 'Explore how engineering effort is allocated by work type.',
    starters: [
      'Which work category consumes the most engineering effort?',
      'How has our work mix changed over time?'
    ]
  },
  '/projects': {
    title: 'Projects',
    description: 'Compare effort and ownership across projects.',
    starters: [
      'Which projects receive the most engineering investment?',
      'Where is project effort changing most quickly?'
    ]
  },
  '/tags': {
    title: 'Tags',
    description: 'Explore engineering effort across developer groups.',
    starters: [
      'How is engineering effort split across our developer tags?',
      'Which tagged group has changed most this period?'
    ]
  },
  '/ai-adoption': {
    title: 'AI Leverage',
    description: 'Understand the effort and cost impact of AI usage.',
    starters: [
      'How has AI leverage changed over this period?',
      'Where are we seeing the most value from AI?'
    ]
  },
  '/ai-leverage/developers': {
    title: 'AI Leverage · Developers',
    description: 'Compare human and AI contribution across developers.',
    starters: [
      'Which developers have the highest AI leverage?',
      'How has developer AI leverage changed over this period?'
    ]
  },
  '/ai-leverage/repositories': {
    title: 'AI Leverage · Repositories',
    description: 'Compare human and AI contribution across repositories.',
    starters: [
      'Which repositories have the highest AI leverage?',
      'Where is AI saving the most effort?'
    ]
  },
  '/ai-leverage/projects': {
    title: 'AI Leverage · Projects',
    description: 'Compare human and AI contribution across projects.',
    starters: [
      'Which projects have the highest AI leverage?',
      'How is AI leverage changing across projects?'
    ]
  },
  '/retention': {
    title: 'Effort Survival Cohort',
    description:
      'Understand how durable past engineering effort remains across cohorts.',
    starters: [
      'What is driving our effort survival trend?',
      'Which cohort has the strongest long-term surviving effort?'
    ]
  },
  '/developer-report': {
    title: 'Developer Report',
    description: 'Review the selected developer’s work, health, and activity.',
    starters: [
      'What is the key trend for this developer?',
      'What recent activity best explains this developer’s metrics?'
    ]
  },
  '/repo-report': {
    title: 'Repository Report',
    description: 'Review the selected repository’s ownership and delivery.',
    starters: [
      'What is the key delivery trend for this repository?',
      'Who is contributing most to this repository?'
    ]
  },
  '/project-report': {
    title: 'Project Report',
    description: 'Review the selected project’s ownership and delivery.',
    starters: [
      'What is the key delivery trend for this project?',
      'Which repositories drive the most effort in this project?'
    ]
  }
};

const SETTINGS_CONTEXT = {
  title: 'GitMe settings',
  description: 'Get help with the configuration on this page.',
  starters: [
    'What does this setting control?',
    'What should I review before changing this configuration?'
  ]
};

export const getChatbotContext = pathname => {
  if (CONTEXTS[pathname]) return CONTEXTS[pathname];
  if (pathname?.startsWith('/settings/')) return SETTINGS_CONTEXT;
  return DEFAULT_CONTEXT;
};
